import React, {useEffect} from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import {Provider} from "react-redux";
import store, {persistor} from "./store";
import {Route, Switch} from "react-router";
import {PersistGate} from "redux-persist/integration/react";
import {HomeContainer} from "./containers/Home";
import {LoginContainer} from "./containers/Login";
import {BrowserRouter} from "react-router-dom";
import {DemoContainer} from "./containers/Demo";
import {DockContainer} from "./containers/Dock";
import PrivateRoute from "./containers/PrivateRoute";
import GlobaSnackbar from "./containers/GlobalSnackbar";
import {LP} from "./containers/LP";
import firebase from "firebase";
import {StylesProvider} from "@material-ui/core";

const App = () => {
    useEffect(() => {
        firebase.auth();
    }, []);

    return (
        <React.StrictMode>
            <StylesProvider injectFirst>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <BrowserRouter>
                            <>
                                <Switch>
                                    <Route
                                        exact
                                        path="/"
                                        component={HomeContainer}
                                    />
                                    <Route
                                        exact
                                        path="/login"
                                        component={LoginContainer}
                                    />
                                    <Route
                                        exact
                                        path="/demo"
                                        component={DemoContainer}
                                    />
                                    <Route exact path="/lp" component={LP} />
                                    <PrivateRoute
                                        exact
                                        path="/dock"
                                        component={DockContainer}
                                    />
                                    <Route
                                        render={() => (
                                            <div
                                                style={{
                                                    textAlign: "center",
                                                    marginTop: "10vh",
                                                }}
                                            >
                                                Not Found
                                            </div>
                                        )}
                                    />
                                </Switch>
                            </>
                            <GlobaSnackbar />
                        </BrowserRouter>
                    </PersistGate>
                </Provider>
            </StylesProvider>
        </React.StrictMode>
    );
};

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
